<ng-container *accessView="['PrimaryCarePhysicianHistory.Read']">
  @if (primaryCarePhysicianHistory$ | async; as primaryCarePhysicianHistory) {
    <div class="mt-8">
      <div class="my-4 font-semibold">
        PCP Contract Info
      </div>
      <p-table
        responsiveLayout="scroll"
        [value]="primaryCarePhysicianHistory"
        [paginator]="true"
        [alwaysShowPaginator]="false"
        [rows]="10"
        >
        <ng-template pTemplate="header">
          <tr>
            <th>PCP Contract State</th>
            <th>PCP Effective Date</th>
            <th>PCP Term Date</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template let-contactInfo pTemplate="body">
          <tr>
            <td>{{ contactInfo.physicianContractState }}</td>
            <td>{{ contactInfo.physicianEffectiveDate | date: 'MM/dd/yyyy'}}</td>
            <td>{{ contactInfo.physicianEndDate | date: 'MM/dd/yyyy'}}</td>
            <td>{{ contactInfo.status }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="flex justify-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</ng-container>

